import React from "react";
import PropTypes from "prop-types";
import { Info } from "lucide-react";
import { NoData } from "../../../../Components/ui";

const AboutEmptyState = ({
  title = "No Content Available",
  description = "Ecosystem overview information is currently being updated. Please check back shortly.",
  actionText = "Back to Home",
  onAction,
}) => {
  return (
    <NoData
      title={title}
      description={description}
      icon={<Info size={32} />}
      actionText={actionText}
      onAction={onAction}
      minHeight={300}
    />
  );
};

AboutEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  actionText: PropTypes.string,
  onAction: PropTypes.func,
};

export default AboutEmptyState;
